// Models
import { UIStateModel } from '@app/models/ui.model';

export class SetLoading {
  static readonly type = '[SetLoading] action';
  constructor(readonly payload: boolean) {}
}

export class SetBanner {
  static readonly type = '[Setbanner] action';
  constructor(readonly payload: UIStateModel['app']['banner']) {}
}

export class SetIncidentUIState {
  static readonly type = '[SetIncidentUIState] action';
  constructor(readonly payload: UIStateModel['incidentUI']) {}
}

export class SetHTTPErrors {
  static readonly type = '[SetHTTPErrors] action';
  constructor(readonly payload: UIStateModel['httpErrors']) {}
}

export class ClearHTTPErrors {
  static readonly type = '[ClearHTTPErrors] action';
}

export class ShowErrors {
  static readonly type = '[ShowErrors] action';
}
